<template>
    <el-row>
        <el-col :span="5" :xs="24" class="mb-2 mb-sm-0 text-right">
            <Button type="primary" @click="onOpenDialog">
                <i class="el-icon-chat-dot-square mr-2"></i>
                {{ $t('recordForm.updateNotes') }}
            </Button>
        </el-col>
        <el-dialog :visible.sync="dialogVisible" class="dialog-custom dialog-custom-large">
            <template slot="title">
                <h5 class="modal-title">{{ $t('recordForm.updateNotes') }}</h5>
            </template>
            <slot name="content">
                <box-loading v-if="isLoading"></box-loading>
                <div v-else class="px-0 px-sm-3">
                    <InputField classes="mb-2 mb-sm-3" :label-text="$t('recordForm.note')" :span-label="2" :span-input="22">
                        <vue-editor v-model="notes" class=""></vue-editor>
                    </InputField>
                </div>
            </slot>
            <div slot="footer" class="dialog-footer">
                <div class="text-right py-2">
                    <Button type="warning" @click="dialogVisible = false" classes="mr-2">
                        {{ $t('button.cancel') }}
                    </Button>
                    <Button type="primary" :disabled="isLoading" v-loading="isLoading" @click="updateNotes" classes="btn-sm"> {{ $t('recordForm.addNotes') }} </Button>
                </div>
            </div>
        </el-dialog>
    </el-row>
</template>
<script>
import Button from '@/components/partials/Button.vue';
import InputField from '@/components/partials/InputField.vue';
import InputText from '@/components/partials/customs/InputText.vue';
import { VueEditor } from 'vue2-editor';
import BoxLoading from '@/components/partials/BoxLoading.vue';

export default {
    name: 'input-notes',
    props: {},
    components: {
        BoxLoading,
        InputText,
        InputField,
        Button,
        VueEditor
    },
    data() {
        return {
            isLoading: false,
            dialogVisible: false,
            notes: ''
        };
    },
    methods: {
        getDetailDataLinkMulti() {
            this.isLoading = true;
            let successCallback = (response) => {
                this.notes = response.data?.data?.data?.note ?? '';
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };

            let payload = {
                successCallback,
                errorCallback,
                id: this.$route.query.id
            };
            this.$store.dispatch('dataLinkMulti/detail', payload);
        },
        onOpenDialog() {
            this.dialogVisible = true;
            this.getDetailDataLinkMulti();
        },
        updateNotes() {
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = (response) => {
                if (response.status === 200) {
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('share.msgCreateSuccess')
                    });
                }
                this.dialogVisible = false;
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let dataPayload = {
                notes: this.notes
            };
            let payload = {
                successCallback,
                errorCallback,
                data: dataPayload,
                id: this.$route.query.id ?? ''
            };
            this.$store.dispatch('dataLinkMulti/updateNotes', payload);
        }
    }
};
</script>
